// extracted by mini-css-extract-plugin
export var closeButton = "_ge-1";
export var closeX = "_ge-3";
export var container = "_ge-0";
export var image = "_ge-2";